<template>
  <div class="animated fadeIn">
    <div class="container">
      <clientselection
        v-if="isMSMUser || hasDashboardCustomerSelection()"
        v-on:clientselectionchanged="onClientSelectionChanged"
      />

      <div class="row">
        <div class="col-xl">
          <div ref="cockpit" v-bind:class="{ spinner: isLoading }">
            <div class="col-md-auto excelButtonTooltip" >

              <div class="py-1">
                <b-form-checkbox switch size="md" @change="changeDisplay" v-model="display.wurstbrot">
                  {{ $t('Webportal.CX.SwitchDisplay') }}
                </b-form-checkbox>
              </div>

              <div class="mx-3">
                <b-button v-if="hasFileImport && localUserProfile.Permissions.includes('Import')" 
                          id="importButton" size="sm" variant="primary" to="cx/importmarginfile"
                          class="app-ctrl">
                  <font-awesome-icon icon="file-import" /> {{ $t('Webportal.Import') }}
                </b-button>
              </div>
<!--               
              <div>
                <b-dropdown v-if="tabIndex <= 1"
                            class="exportGroup"
                            right
                            split 
                            variant="success"
                            @click="excelExport('all')"
                            :disabled="isLoadingExport" 
                            v-b-tooltip.hover.top="$t('Webportal.CX.ExportAllButton')"
                            size="sm">
                  <template #button-content>
                    <font-awesome-icon icon="file-excel" /> {{ $t('Webportal.CX.Export') }}
                  </template>
                  <b-dropdown-item-button @click="excelExport('selected')">                  
                    <font-awesome-icon icon="file-excel" /> {{$t('Webportal.CX.ExportSelectedButton')}}
                  </b-dropdown-item-button>
                </b-dropdown>
              </div> -->

            </div>

            <b-card no-body class="mb-5">
              <b-tabs small class="app-ctrl app-ctrl-tabs"
                      card
                      v-if="ClientSelected"
                      v-model="tabIndex"
                      @activate-tab="activateTab">
                
                <!-- Markets Tab (disabled ???) -->
                <b-tab  lazy class="app-ctrl"
                        :title="$t('Webportal.CX.Market')"
                        v-if="!countryData || !showCountries"
                        title-item-class="disabledTab" />

                <!-- Markets Tab -->
                <b-tab  v-else-if="showCountries" class="app-ctrl"
                        active
                        lazy
                        :title="$t('Webportal.CX.Market')" >
                  <cxMarket ref="market"
                            :countryData="countryData"
                            :clientId="ClientSelected"
                            :overall="marketOverall"
                            :colorRange="FallbackColorRange"
                            :theme="theme.selected"
                            :alternativeDisplay="display.alternative"
                            :waves="waves"
                            :wavesSelected="wavesSelected"
                            @updated:alternativeDisplay="changeDisplayDone"
                            @drilldownToRetailer="drilldownToRetailer" />
                </b-tab>

                <!-- Retailers Tab (disabled ???) -->
                <b-tab  lazy class="app-ctrl"
                        :title="$t('Webportal.CX.Retailer')"
                        v-if="!showRetailer"
                        title-item-class="disabledTab" />

                <!-- Retailers Tab -->
                <b-tab  :title="$t('Webportal.CX.Retailer')"
                        v-if="showRetailer" class="app-ctrl"
                        id="retailerTab">
                  <cxRetailer ref="retailer"
                              :key="retailerReloadKey"
                              :retailerData="retailerData"
                              :colorRange="FallbackColorRange"
                              :defaultLogo="DefaultLogo"
                              :clientId="ClientSelected"
                              :countryId="CountrySelected"
                              :scoreId="scoreId"
                              :theme="theme.selected"
                              :alternativeDisplay="display.alternative"
                              :waves="waves"
                              :wavesSelected="wavesSelected"
                              @updated:alternativeDisplay="changeDisplayDone"
                              @drilldownToDashboard="drilldownToDashboard"
                              @drilldownToMarkets="drilldownToMarkets"
                              @downloadReport="downloadReport"
                              @loadData="getRetailer" />
                </b-tab>

                <!-- Details Tab / No Dashboard -->
                <b-tab  :title="$t('Webportal.CX.Dashboard')"
                        v-if="!showDashboard" class="app-ctrl"
                        title-item-class="disabledTab" />
                
                <!-- Details Tab / Dashboard -->
                <b-tab  :title="$t('Webportal.CX.Dashboard')" class="app-ctrl"
                        v-if="showDashboard">
                  <cxDashboard  v-if="DashboardData"
                                :dashboardData="DashboardData"
                                :clientLocationId="RetailerSelected"
                                :defaultLogo="DefaultLogo"
                                :colorRange="FallbackColorRange"
                                :theme="theme.selected"
                                :retailerSelected="RetailerSelected" />
                </b-tab>

                <template #tabs-end>
                  <treeselect v-if="tabIndex <= 1"
                              :disabled="!filterData"
                              v-model="filterSelected"
                              class="tree-select"
                              :options="filterDataScenarios"
                              :multiple="true"
                              :showCount="true"
                              @close="reloadCurrentTab"
                              @input="inputCurrentTab">
                  </treeselect>

                  <treeselect v-if="tabIndex <= 1 && display.alternative === true"
                              :disabled="waves.length === 0"
                              class="tree-select"
                              v-model="wavesSelected"
                              :options="waves"
                              :limit="3"
                              :multiple="true"
                              :showCount="true"
                              @close="reloadCurrentTab"
                              @input="inputCurrentTab">
                  </treeselect>
                </template>
              </b-tabs>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import CancelToken from "@/mixins/CancelToken";
import DownloadFileMixin from '@/mixins/DownloadFileMixin';
import i18n from '@/i18n';

import EventBus from "@/services/EventBus.js";
import AuthenticationService from "@/services/AuthenticationService";
import DashboardService from "@/services/DashboardService";
import AdministationService from "@/services/AdministationService";
import ReportsService from '@/services/ReportsService';

import cxMarket from "@/components/CX/Market";
import cxRetailer from "@/components/CX/Retailer";
import cxDashboard from "@/components/CX/Dashboard";

import clientselection from "./ClientSelection";

export default {
  name: "CX",

  mixins: [AppConfig, CancelToken, DownloadFileMixin ],

  components: {
    clientselection,
    cxMarket,
    cxRetailer,
    cxDashboard
  },

  watch: {
    tabIndex: {
      handler(newVal, oldVal) {
        this.changeHistory(newVal);
      }
    },
    RetailerSelected: {
      handler(newVal, oldVal) {
        this.DashboardData = null;
      }
    }
  },

  created() {
    if (!this.isMSMUser) {
      this.ClientSelected = AuthenticationService.localUserProfile.ClientId;
      this.getClientSettings();
    }

    EventBus.$on("LocalizationChanged", this.reloadCurrentTab);
    EventBus.$on("GetCX_Filter", this.getCX_Filter);
    EventBus.$on("Score_Changed", (selectedScoreId) => {
      this.scoreId = selectedScoreId;
      this.getDealer(selectedScoreId);
    })
  },

  async mounted() {
    this.initializeTheme();

    await this.getFilterData(true);

    // this.getCountriesData();

    // Reset history state to prevent funny behavior
    window.history.replaceState(null, null);

    // Handle back clicks for history
    window.addEventListener("popstate", this.changeHistoryHandler);
  },

  beforeDestroy() {
    window.removeEventListener("popstate", this.changeHistoryHandler);
    EventBus.$off("LocalizationChanged", this.reloadCurrentTab);
    EventBus.$off("GetCX_Filter", this.getCX_Filter);
    EventBus.$off("Score_Changed");
  },

  data() {
    return {
      display: {
        alternative: false
      },

      countryData: {},
      countriesCancelToken: null,

      retailerData: {},
      retailerCancelToken: null,

      filterData: null,
      filtersCancelToken: null,
      filterSelected: [],

      wavesSelected: [],

      DefaultLogo: null,

      ColorRange: null,
      DashboardData: null,

      ClientSelected: null,
      CountrySelected: null,
      RetailerSelected: null,

      showCountries: true,
      showRetailer: false,
      showDashboard: false,

      marketOverall: [],

      isLoadingExport: false,
      isLoadingFilter: false,
      isLoadingSettings: false,
      isLoadingCountries: false,
      isLoadingDealer: false,
      isLoadingRetailer: false,
      retailerReloadKey: 0,
      scoreId: null,

      optionsCancelToken: null,

      tabIndex: 0,

      toolTipDelay: { delay: { show: 500, hide: 100 } },

      // The original paging is in Retailer, but it is needed to store temporarily
      pageSize: 999, // Number of items on one page of the table
      selectedPage: 1, // Number of the page, that is currently visible
      searchText: { Value: null, Changed: false },

      FallbackColorRange: [
        {
          Minimum: 0,
          Maximum: 69.99,
          Color: "#f54052",
          Smiley: 'frown-open'
        },
        {
          Minimum: 70,
          Maximum: 89.99,
          Color: "#FFD700",
          Smiley: 'meh'
        },
        {
          Minimum: 90,
          Maximum: 100,
          Color: "#36c259",
          Smiley: 'grin'
        }
      ]
    };
  },

  methods: {
    activateTab(event) {
      switch (event) {
        case 0:
          this.showCountries = true;
          this.showRetailer = false;
          this.showDashboard = false;
          break;
        case 1:
          this.showCountries = true;
          this.showRetailer = true;
          this.showDashboard = false;
          break;
        case 2:
          this.showCountries = true;
          this.showRetailer = true;
          this.showDashboard = true;
          break;
      } 
      this.tabIndex = event;
    },

    async changeDisplay(event)  {
      this.isLoadingCountries = true;
      this.display.wurstbrot = event;
      this.$nextTick(() => {
        this.delay(100).then(() => {
          this.display.alternative = event;
        });
      });
    },

    changeDisplayDone(event) {
      this.isLoadingCountries = false;
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    downloadReport(options) {
      this.isLoadingExport = true;

      ReportsService.getCheckReports(
        options.LastSurveyInstanceIds.map(x => Number(x.SurveyInstanceId)),
        {
          'UseSurveyDefaultLocalization': true,
          'LocalizationId': i18n.locale
        })
      .then(response => {
        this.isLoadingExport = false;
        if (response.status === 204 || response.status === 500)
          this.$bvToast.toast(
            this.$t("Webportal.NoDataFound"),
            {
              autoHideDelay: 5 * 1000,
              variant: "warning",
              noCloseButton: true,
            }
          );
        else
          this.downloadFile(response);
      })
      .catch(_ => { this.isLoadingExport = false; } );
    },

    excelExport(param) {
      // Use AG-Grid export
      this.isLoadingExport = true;
      if (this.tabIndex < 2 && param) {
        try {
          if (this.tabIndex === 0) {
            this.$refs.market.exportExcel({ table: 'Market', mode: param });
          } else if (this.tabIndex === 1) {
            this.$refs.retailer.exportExcel({ table: 'Retailers', mode: param });
          }
        } catch (err) {
          console.error(err)
        } finally {
          this.isLoadingExport = false;
        }
        return;        
      }

      // Workaround: The tooltip doesn't hide as the button is disabled and disabled elements
      // can't be (un)focused - parent elements are a bit iffy in this specific case
      // this.$root.$emit('bv::hide::tooltip', 'excelButton')
      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      // Filter depends on selected tab
      const filter = {
        "client-id":  this.ClientSelected,
        "country-id": (this.tabIndex >= 1) ? this.CountrySelected : null,
        "clientlocation-id": (this.tabIndex >= 2) ? this.RetailerSelected : null,
        "localization-id": i18n.locale
      };

      // Set spinning cursor
      document.body.style.cursor = "progress";

      DashboardService.getCxReport(filter, this.optionsCancelToken)
        .then(response => this.downloadFile(response))
        .catch(error => console.error(error))
        .finally(() => {
          this.isLoadingExport = false;
          document.body.style.cursor = null;
        });
    },

    changeHistoryHandler(event) {
      this.changeHistory(event.state);
    },

    changeHistory(tabId) {
      // Handle programatically set tab index:
      // The state was set first and tabIndex is changed afterwards
      // tabIndex will call this function again and we can filter it:
      if (tabId == null || window?.history?.state?.tabId === tabId) return;

      // Handle popstate by setting old state
      if (typeof tabId === "object") {
        window.history.replaceState(tabId, null);
        this.tabIndex = tabId.tabId;
        return;
      }

      // Handle drilldown and clicking on tab by replacing state (reset)
      window.history.pushState({ tabId }, null);
      this.tabIndex = tabId;
    },

    drilldownToMarkets() {
      this.retailerReloadKey++;
      this.showRetailer = false;
      this.showDashboard = false;
      this.tabIndex = 0;
    },

    drilldownToRetailer(countryId, overall = undefined) {
      this.retailerReloadKey++;
      this.showRetailer = true;
      this.showDashboard = false;
      this.CountrySelected = countryId;

      this.tabIndex = 1;
      return this.getRetailer(null, 1, this.pageSize);
    },

    drilldownToDashboard(clientLocationId) {
      this.showDashboard = true;
      try {
        this.RetailerSelected = typeof clientLocationId === 'string' ? parseInt(clientLocationId) : clientLocationId;
      } catch (err) {
        console.error(err);
      }

      this.tabIndex = 2;
      document.activeElement.blur();
      return this.getDealer(-1);
    },

    // CX RM: CX TODO - Rework - Filter for history
    getCX_Filter(callback) {
      if (typeof callback !== "function") return;

      callback({
        client: this.ClientSelected,
        locations: this.RetailerSelected,
        countries: this.CountrySelected
      });
    },

    inputCurrentTab(event) {
      if (event && event.length === 0) {
        this.reloadCurrentTab();
      }
    },

    reloadCurrentTab(localizationId) {
      // (Re)load data depending on current tabIndex
      switch (this.tabIndex) {
        case 0:
          if (this.filterData)
            return this.getCountriesData();
          else 
            return Promise.reject();

        case 1:
          return this.getRetailer();

        case 2:
          return this.getDealer(-1);

        default:
          return Promise.reject();
      }
    },

    getFilterData(mount) {
      if (this.ClientSelected == null){
        return;
      } 
   
      this.isLoadingFilter = true;
      this.isLoadingCountries = true;
      this.filtersCancelToken = this.initCancelToken(this.filtersCancelToken);

      return DashboardService.getCxFilterData(
        { 
          ClientId: this.ClientSelected,
          CountryId: this.CountrySelected
         },
        this.filtersCancelToken)
        .then(response => {
          this.isLoadingFilter = false;
          this.filterData = _.isEmpty(response.data) ? null : response.data;
          this.getCountriesData();
        })
        .catch(error => {
          this.isLoadingFilter = false;
          console.error(error);
        });
    },

    getCountriesData() {
      if (this.ClientSelected == null) return;

      const marketFilters = {
        ClientId: this.ClientSelected,
        scenarios:  this.filterSelected.length > 0 ? this.filterSelected.join(",") : null,
        waves: this.waves.filter(x => this.wavesSelected.includes(x.label)).flatMap(x => x.ids)
      }

      this.countriesCancelToken = this.initCancelToken(this.countriesCancelToken);

      return DashboardService.getCxMarketData(marketFilters, this.countriesCancelToken)
        .then(response => {
          // needed, filters call is slower than this call, atm not found a solution to bring them in line 
          this.delay(500).then(() => {
            this.countryData = this.findAllWaves(response.data);
          });
        })
        .finally(() => {
          this.isLoadingCountries = false;
        });
    },
    
    findAllWaves(data) {
      const waveSet = new Set();
      
      if (!data.Countries)
        data.Countries = [];
      data.Countries.forEach(x => {x.questions = [];});

      if (!data.Question)
        data.Question = [];
      if (!data.Question)
        data.Question = [];
      if (!data.ClusterGroup)
        data.ClusterGroup = [];

      const countryLookup = data.Countries.reduce((acc, country) => {
        acc[country.CountryId] = country.CountryName;
        return acc;
      }, {});

      data.ClusterGroup = data.ClusterGroup.map(cluster => ({
        ...cluster,
        CountryName: countryLookup[cluster.CountryId] || undefined
      }));

      for (const question of data?.Question || []) {
        for (const wave of question.SurveyWave) {
          waveSet.add(wave.Name);
          question[wave.Name] = wave.Result.replace(',', '.');
          question[wave.Name + 'n'] = wave.CheckCountTotal;
        }
      }
      // Sort waves by year and quarter
      data.waves = Array.from(waveSet).sort((a, b) => {
        // 'Total' should always come first
        if (a === 'Total') return -1;
        if (b === 'Total') return 1;

        // Extract year and quarter
        const [qa, ya] = a.slice(1).split('-').map(Number);
        const [qb, yb] = b.slice(1).split('-').map(Number);

        // Sort by year first, then by quarter
        if (ya !== yb) {
          return ya - yb;
        } else {
          return qa - qb;
        }
      });
      return data;
    },

    handleRetailerData(data) {
      // TODO: keine Questions, nur Locations!
      // TODO: Und immer alle Locations, aus Locations anzeigen
      for (const q of data?.Question || []) {
        let l = data.Locations.find(x => x.ClientLocationId === q.ClientLocationId);
        if (l) {
          q.City = l.City;
          q.ClientLocationIdOnClientSite = l.ClientLocationIdOnClientSite;
          q.Name = l.Name;
          q.PostalCode = l.PostalCode;
        }
      }

      return data;
    },

    getRetailer(searchText, selectedPage, pageSize) {
      if (this.searchText.Value === searchText) {
        this.searchText.Changed = false;
      } else {
        this.searchText.Value = searchText;
        this.searchText.Changed = true;
      }

      if (this.searchText.Changed) selectedPage = 1;
      if (selectedPage) this.selectedPage = selectedPage;
      if (pageSize) this.pageSize = pageSize;

      if (this.CountrySelected == null)
        return;

      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      this.isLoadingRetailer = true;

      return DashboardService.getCxRetailerData(
        {
          ClientId:   this.ClientSelected,
          scenarios:  this.filterSelected.length > 0 ? this.filterSelected.join(",") : null,
          CountryId:  this.CountrySelected
        },
        this.retailerCancelToken
      ).then(response => {
        this.retailerData = this.findAllWaves(this.handleRetailerData(response.data));
      })
      .finally(() => {
        this.isLoadingRetailer = false;
      });
    },

    getDealer(scoreId) {
      if (this.RetailerSelected == null || this.CountrySelected == null || this.ClientSelected == null) {
        this.drilldownToRetailer(this.CountrySelected);
        return Promise.resolve();
      }

      this.isLoadingDealer = true;
      

      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      return DashboardService.getDealer(
          this.RetailerSelected,
          this.optionsCancelToken,
          scoreId
        )
        .then(response => {
          this.DashboardData = null;
          if (response.data) {
            this.DashboardData = response.data;
          } else if (this.isMSMUser) {
            // Redirect to Market needed
            // this.drilldownToRetailer(this.CountrySelected);
          }
        })
        .finally(() => {
          this.isLoadingDealer = false;
        });
    },

    // ***********************************************************
    // HTML Events
    // ***********************************************************

    // Client Selection (for MSMUser)
    // ******************************
    onClientSelectionChanged(clientSettings) {
      if (clientSettings) {
        this.ClientSelected = clientSettings?.ClientId || null;
        this.getFilterData();
      }

      // Reset all slections after client change
      this.tabIndex = 0;
      this.showRetailer = false;
      this.showDashboard = false;
      this.showCountries = true;

      this.DashboardData = null;

      this.setClientSettings(clientSettings);
      this.reloadCurrentTab()
        .then(() => EventBus.$emit("ClientChanged"));
    },

    // ***********************************************************
    // Private methods
    // ***********************************************************
    getClientSettings(clientId) {
      return AdministationService.getClientSettings(clientId || this.ClientSelected)
        .then(response => this.setClientSettings(response?.data?.[0]));
    },

    setClientSettings(clientSettings) {
      if (!clientSettings) return;

      this.ColorRange = clientSettings.Thresholds;
      this.DefaultLogo = clientSettings.LogoExternalImageId
        ? process.env.BASE_URL + `api/media/image?id=${clientSettings.LogoExternalImageId}`
        : process.env.BASE_URL + "static/img/msm_loop_logo_40px.png";
    }
  },

  computed: {
    filterDataScenarios() {
      return this.filterData?.scenarios || [];
    },

    isMSMUser: function() {
      return AuthenticationService.isMSMUser;
    },

    localUserProfile: function () {
      return AuthenticationService.localUserProfile;
    },

    hasFileImport() {
      return APP_TARGET === "jlr";
    },

    isLoading() {
      return (
        this.isLoadingSettings ||
        this.isLoadingFilter ||
        this.isLoadingCountries ||
        this.isLoadingDealer ||
        this.isLoadingRetailer ||
        this.isLoadingExport
      );
    },

    waves() {
      return (this.filterData?.waves || []).reduce((acc, item) => {
        let existing = acc.find(entry => entry.label === item.label);
        if (existing) {
          existing.ids.push(item.id);
          existing.surveyIds.push(item.surveyId);
        } else {
          acc.push({
            id: item.label,
            label: item.label,
            ids: [item.id],
            IsDefault: item.IsDefault,
            IsLocalWave: item.IsLocalWave,
            shortName: item.shortName,
            surveyIds: [item.surveyId],
            WaveDate: item.WaveDate
          });
        }
        return acc;
      }, []);
    }
  }
};
</script>

<style scoped>
.container {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
  width: 100%;
}

.card {
  margin-bottom: 20px;
  word-wrap: unset;
}

.card-body {
  min-height: 150px;
}

.excelButton {
  background-color: #107c41;
  border-color: #107c41;
}

.excelButtonTooltip {
  z-index: 1;
  display: inline-flex;
  float: right;
  position: relative;
  bottom: -10px;
  right: 3px;
  margin-bottom: -50px;
}

.right-tools {
  display: inline-block;
  position: relative;
  z-index: 1;
  float: right;
  position: relative;
}

b-dropdown.exportGroup > * {
  background-color: #107c41!important;
  color: #eee!important;
}

.tooltip {
  /* Workaround: https://github.com/bootstrap-vue/bootstrap-vue/issues/1732 */
  top: 0;
}

.b-tabs .nav {
  display: flex;
  align-items: center;
}
.b-tabs .ml-auto {
  margin-left: auto;
}

.tree-select {
  margin-right: 10px;
  width: 24rem;
}
</style>

<style>
.disabledTab {
  pointer-events: none;
}

.disabledTab > .nav-link {
  pointer-events: none;
  display: none;
  color: rgba(255, 255, 255, 0) !important;
  cursor: not-allowed;
}
</style>
